// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3INke","placeholdersHeader":"styles_placeholdersHeader__HvLBE","editorStyle":"styles_editorStyle__wz4pM","placeholdersBox":"styles_placeholdersBox__Lsu0n"};